import {useEffect, useMemo, useState} from "react";
import DBTable from "../../../../../component/global/DBTable/DBTable";
import {get} from "../../../../../controlers/global/ConfigRequest";
import {GET_PACKAGE_LOGS} from "../../../../../helperData/ApiAddress";
import moment from "moment-jalaali";
import {Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const headers = [
  {
    id: 'row',
    title: 'ردیف',
    gridTemplateColumns: '55px'
  },
  {
    id: 'receipt',
    title: 'شماره فاکتور',
    gridTemplateColumns: '90px'
  },
  {
    id: 'price',
    title: 'مبلغ',
    gridTemplateColumns: '100px',
    numberWithComma: true,
  },
  {
    id: 'startDate',
    title: 'تاریخ شروع',
    gridTemplateColumns: '100px',
    rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
    headerStyle: {},
  },
  {
    id: 'endDate',
    title: 'تاریخ پایان',
    gridTemplateColumns: '100px',
    rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
  },
  {
    id: 'status',
    title: 'وضعیت',
    gridTemplateColumns: '100px',
  },
]

function Receipt() {
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])
  const {t} = useTranslation()

  const headers = useMemo(() => {
    return [
      {
        id: 'row',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.Row'),
        gridTemplateColumns: '55px'
      },
      {
        id: 'receipt',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.Receipt'),
        gridTemplateColumns: '90px'
      },
      {
        id: 'price',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.Price'),
        gridTemplateColumns: '100px',
        numberWithComma: true,
      },
      {
        id: 'startDate',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.StartDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
        headerStyle: {},
      },
      {
        id: 'endDate',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.EndDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
      },
      {
        id: 'status',
        title: t('Organizational.Profile.Packages.Report.Receipt.Table.Status'),
        gridTemplateColumns: '100px',
      },
    ]
  }, [t])


  useEffect(() => {
    get(GET_PACKAGE_LOGS)
      .then(res => {
        console.log('res', res)
        if (res?.results?.length) {
          const tmp = res.results.map((item, index) => {
            const startDate = moment(item.created_at).format('jYYYY/jMM/jDD')
            const startTime = moment(item.created_at).format('HH:MM')
            let endDate = ''
            let endTime = ''
            if (item.duration_as_days) {
              const date = moment(item.created_at).add(item.duration_as_days, 'd')
              endDate = date.format('jYYYY/jMM/jDD')
              endTime = date.format('HH:MM')
            }
            return {
              row: index + 1,
              receipt: item.code,
              price: item.price,
              startDate: `${startDate} \n ${startTime}`,
              endDate: `${endDate} \n ${endTime}`,
              status: `پرداخت نشده`,
            }
          })
          setRows(tmp)
        }
      })
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <Spinner animation="border" style={{marginTop: 20}}/>;
  return (
    <div>
      <DBTable width={611} headers={headers} rows={rows}/>
    </div>
  );
}

export default Receipt;
